<!--关注店铺-->
<template>
  <div class="follow-container" :style="'min-height:'+min_height+'px;'">
    <div class="follow-content" v-if="hasShop">
      <el-row :gutter="16">
        <el-col :span="8" v-for="(follow,index) of followData" v-if="follow.shopId!=0">
          <div class="follow-list">
            <div class="unfollow-link" @click="cancelAttend(follow)">
              <el-link :underline="false" style="color: #333333;">取消关注</el-link>
            </div>
            <el-image style="width: 100%; height: 100px;" fit="contain" :src="follow.shopHomeSerach.img"/>
            <div class="name">
              <p class="follow-name SourceHanSansCN">{{ follow.shopHomeSerach.name }}</p>
            </div>
            <div class="follow-icon">
              <el-link :underline="false" style="color: #333333;">
                <i class="iconfont icon-love"/>{{ follow.shopHomeSerach.followersNum }}
              </el-link>
            </div>
            <div class="bottom-link">
              <el-link class="follow-bottom-link" :underline="false"
                       style="border-right: none;border-left: none;border-bottom: none"
                       @click="shopInfo(follow.shopHomeSerach.id)">
                <i class="iconfont icon-bqw-shop2" style="padding-right: 5px;"/>进入店铺
              </el-link>
              <el-link class="follow-bottom-link" :underline="false" style="border-right: none;border-bottom: none">
                <i class="iconfont icon-bqw-customer" style="padding-right: 5px;"/>联系客服
              </el-link>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="follow-content">
      <el-empty description="没有关注店铺"/>
    </div>
  </div>
</template>
<script>
import {shopArticleList, removeCollect} from '@/api/interfaceApi'
import cityJson from "@/static/cityJson.json";

export default {
  name: "follow",
  data() {
    return {
      followData: [],
      min_height: document.documentElement.clientHeight - 346,
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      hasShop:false,
      cityList:{},
    }
  },
  methods: {
    /*取消关注*/
    cancelAttend(data) {
      let cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
      removeCollect({
        isHead: true,
        request: 'form',
        userId: cid != 0 && cid != undefined ? cid : 0,
        type: data.type,
        ids: data.shopId,
        uid: cid != 0 && cid != undefined ? cid : 0
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.getFollowInfo();
        }
      })
    },
    /*店铺信息*/
    shopInfo(id) {
      let routeData = this.$router.resolve({
        name: "shop",
        path: '/storeManagement/shop',
        query:{
          id:id,
          pName: this.cityList.abridge+'企服务云'
        }
      });
      window.open(routeData.href, '_blank')
    },
    /*获取关注店铺*/
    getFollowInfo() {
      let cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
      shopArticleList({pageNum: 0, userId: cid != 0 && cid != undefined ? cid : 0, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.followData = res.content.shopHomeSerachList;
          for (let list of this.followData){
            if (list.shopHomeSerach!=null)
              this.hasShop=true;
          }
          this.tablePage.total = res.content.totalNum;
        }
      })
    },
  },
  mounted() {
    this.getFollowInfo();
  },
  beforeMount() {
    if (sessionStorage.getItem('setPositioning'))
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.follow-container {
  background: #ffffff;

  .follow-content {
    padding: 20px;

    .follow-list {
      border: 1px solid #DEDEDE;
      min-height: 315px;
      display: grid;
      align-items: stretch;

      &:hover {
        border: 1px solid #FE273B;
      }

      &:hover .unfollow-link {
        display: flex;
        justify-content: center;
        background-color: #f1f1f1;
      }

      &:hover .bottom-link {
        background-color: #f1f1f1;
      }

      &:hover .bottom-link .follow-bottom-link {
        border: 0.5px solid #FE273B;
      }

      &:hover .el-image {
        padding-top: 0px;
      }

      .el-image {
        padding-top: 35px;
      }

      .unfollow-link {
        display: none;
        color: #333333;

        &:hover {
          color: #333333;
          background-color: #f1f1f1;
        }
      }

      .name {
        display: flex;
        justify-content: center;

        .follow-name {
          font-size: 16px;
          color: #333333;
        }
      }

      .follow-icon {
        display: flex;
        justify-content: center;
        padding-bottom: 25px;

        .icon-love {
          color: #FE273B;
          font-size: 18px;
          padding-right: 5px;
        }
      }

      .bottom-link {
        display: flex;
        justify-content: space-around;

        .follow-bottom-link {
          color: #333333;
          font-size: 14px;
          width: 50%;
          border: 0.5px solid #DEDEDE;
        }

      }
    }
  }
}
</style>